import styled, { css } from 'styled-components';

export const VideoPlayerContainer = styled.div`
     ${(props) =>
         props.theme &&
         props.isBrowserFullscreen &&
         css`
             height: 100%;

             & > div {
                 height: 100%;
             }
             .${props.theme['video-player__inner']} {
                 background-color: transparent;
             }

             .${props.theme['video-player__video']} {
                 background-color: transparent;
             }

             .${props.theme.poster}, ${props.theme['poster--is-hidden']} {
                 background-color: transparent;
             }

             .${props.theme.poster} {
                 width: 100%;
                 height: 100%;
             }

             .${props.theme.image} {
                 width: 100%;
                 height: 100%;
                 opacity: 0.2;
                 object-fit: contain;
             }

             .${props.theme.image}, ${props.theme['image--is-loaded']} {
                 opacity: 1;
             }

             .${props.theme['errorBoundary-container']} {
                 height: 100%;
             }

             .${props.theme['video-player']} {
                 padding-bottom: 0 !important;
                 height: 100% !important;
                 background-color: transparent !important;
             }
             .${props.theme['cast-status']} {
                 top: 70px;
             }

             .${props.theme['cast-poster']} {
                 height: 100%;
                 object-fit: contain;
             }
         `}

         ${(props) =>
             props.theme &&
             props.isKeepWatching &&
             css`
                 .${props.theme['play-pause-buttom-simple__text']} {
                     text-indent: -999px;
                     &:after {
                         content: 'Fortsätt titta';
                         text-indent: 0;
                         display: block;
                         color: black;
                         margin-top: -16px;
                     }
                 }
             `}

        ${(props) =>
            props.theme &&
            props.isHidden &&
            css`
                .${props.theme['ui-container']} {
                    display: none;
                }

                .${props.theme['video-player__video']} {
                    display: none;
                }

                .${props.theme.image}, ${props.theme['image--is-loaded']} {
                    opacity: 0.2;
                }
            `}
`;
